import { TransactionProductDto } from './transaction-product.dto';
import { TransactionUnitPriceDto } from './transaction-unit-price.dto';

export class TransactionLineProductDto {
  public lineIsCorrected: boolean;
  public product: TransactionProductDto;
  public taxRate: number;
  public quantity: number;
  public netPrice: number;
  public taxAmount: number;
  public grossPrice: number;
  public unitPrice: TransactionUnitPriceDto;
}
